const Action = {
    SET_WELCOME: "set_welcome",
    ERROR: "error",
};

export default Action;